<template>
  <guiide-transition-shallow
    :sectionVisible="showMessage"
    :slideIn="showMessage"
  >
    <div v-show="showMessage" class="alert alert-success my-4" role="alert">
      <i class="bi bi-exclamation-circle-fill me-2"></i>
      <span v-show="showPrefix">{{ messagePrefix }}</span> {{ message }}
    </div>
  </guiide-transition-shallow>
</template>

<script lang="ts">
import GuiideTransitionShallow from "./GuiideTransitionShallow.vue";

export default {
  name: "BadResponseViewer",
  props: {
    messagePrefix: { type: String, required: false, default: "" }
  },
  components: {
    GuiideTransitionShallow
  },
  data() {
    return {
      showMessage: false,
      message: ""
    };
  },
  methods: {
    update(isOk: boolean, message: string) {
      this.message = message;
      this.showMessage = !isOk;
    },
    clear() {
      this.showMessage = false;
      this.message = "";
    }
  },
  computed: {
    showPrefix(): boolean {
      return this.messagePrefix.length > 0;
    }
  }
};
</script>
